export const BikeIcon = ({ width = '24', height = '24', fill = '#0F2664' }) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 19.5C7.20914 19.5 9 17.7091 9 15.5C9 13.2909 7.20914 11.5 5 11.5C2.79086 11.5 1 13.2909 1 15.5C1 17.7091 2.79086 19.5 5 19.5Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.49976 8H14.4998M14.4998 8H14.9998L18.9998 15.5M14.4998 8L16.4998 5M16.4998 5H13.9998M16.4998 5H18.4998"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.00024 15.5002L8.50024 8.00024L12.0002 14.5002H15.0002"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.50024 8C8.16691 7 7.00024 5 5.00024 5"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.0002 19.5C21.2093 19.5 23.0002 17.7091 23.0002 15.5C23.0002 13.2909 21.2093 11.5 19.0002 11.5C16.7911 11.5 15.0002 13.2909 15.0002 15.5C15.0002 17.7091 16.7911 19.5 19.0002 19.5Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
